import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { updateRatingNotification } from '../api';
import { IRatingNotification } from '../interfaces';

const definedIds = (ids: (number | undefined)[]) => ids.filter((id): id is number => id !== undefined);

export function useUpdateRatingNotification(onUpdate?: () => void) {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const updateNotification = async ({ partners, personal }: Pick<IRatingNotification, 'partners' | 'personal'>) => {
    setLoading(true);

    try {
      await updateRatingNotification({
        realEstatePartnerRatingIds: definedIds(partners.list.map((row) => row.realEstatePartnerRatingId)),
        realEstatePersonalRatingIds: definedIds(personal.list.map((row) => row.realEstatePersonalRatingId)),
      });
      onUpdate?.();
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, updateNotification };
}
